import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AccessControlService } from '../pages/auth/services/access-control.service';
import { ORGANIZATION_SETTINGS_ROLES } from '../pages/auth/model/role.model';
import { isProductActiveGuard } from './is-product-active.guard';

function isPayrollSettings(url: string): boolean {
  let path = url.split(/[?#]/)[0];
  if (path.endsWith('/')) path = path.slice(0, -1);
  return path === '/home/organization-settings/payroll';
}

export const organizationSettingsProductGuard: CanActivateFn = (route, state) =>
  isProductActiveGuard(isPayrollSettings(state.url) ? 'Payroll' : 'CoreHR')(route, state);

// Apply to both entry and child navigation: payroll permission must not open other settings tabs.
export const organizationSettingsAccessGuard: CanActivateFn = (_route, state) => {
  const access = inject(AccessControlService);
  const role = access.authStore.role();
  if (role && ORGANIZATION_SETTINGS_ROLES.includes(role)) return true;
  if (isPayrollSettings(state.url) && access.hasPermission('payroll.manage')) return true;
  return inject(Router).createUrlTree(['/home/403-forbidden'], { queryParams: { returnUrl: state.url } });
};
